// extracted by mini-css-extract-plugin
module.exports = {"carInfo":"_1i172","carImage":"_11B7O","image":"_3UzfJ","details":"_1VDcQ","regNo":"_1SKe9"};